// extracted by mini-css-extract-plugin
export default {"mainDivSendMails":"sendReminder_mainDivSendMails__qQz+b","emailUserIconDiv":"sendReminder_emailUserIconDiv__S3riH","shortNameDiv":"sendReminder_shortNameDiv__04DnP"};